import axios from 'axios';
import { BookingCalendar } from 'components/bookingCalendar';
import { BookingCalendarLite } from 'components/bookingCalendarLite';
import { BookingDropdownLite } from 'components/bookingDropdownLite';
import { BarsLoadingIndicator } from 'components/common/barsLoadingIndicator';
import { Drawer } from 'components/common/drawer';
import { Dropdown } from 'components/common/dropdown';
import { Input } from 'components/common/input';
import { Modal } from 'components/common/modal';
import { apiConfig } from 'config';
import { closeModal } from 'features/modalSlice';
import { useGetBookingData } from 'hooks';
import { isMobileDeviceRequest } from 'lib';
import { isArray, isEmpty } from 'lodash';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as constants from './../../constants';
import { toast } from 'react-toastify';
import { FaRegCheckCircle, FaRegTimesCircle } from 'react-icons/fa';

import { BookingHeader } from 'components/bookingHeader';
import './OfferModal.css';
import { Checkbox } from 'components/common/checkbox';

const OfferModal = () => {
    const dispatch = useDispatch();
    const isOpen = useSelector((state) => state.modal.isOfferModalOpen);
    const handleModalClose = useCallback(() => {
        if (!isCalendarOpenModal && !isCalendarOpenDrawer) {
            dispatch(closeModal({ modalId: 'OfferModal' }));
            setTimeout(clearValues, 1000);
        }
    });
    const colors = useSelector(
        (state) => state.miniBookingWidget?.data?.colors
    );
    const propertyID = useSelector(
        (state) => state.miniBookingWidget?.data?.propertyID
    );
    const pluginCountries = useSelector(
        (state) => state.miniBookingWidget?.data?.pluginCountries
    );
    const tempCheckInDate = useSelector(
        (state) => state.user?.checkInDay?.date
    );
    const tempCheckOutDate = useSelector(
        (state) => state.user?.checkOutDay?.date
    );

    const isMobileDevice = isMobileDeviceRequest();
    const { userBookingData } = useGetBookingData();
    const Lang = useSelector((state) => state.miniBookingWidget?.data?.Lang);
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [message, setMessage] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [isCompleted, setIsCompleted] = useState('');
    const [checked, setChecked] = useState(false);
    const [searchOptions, setSearchOptions] = useState({
        numberOfRooms: 1,
        adults: 2,
        children: 0,
    });
    const [datesOptions, setDatesOptions] = useState({
        checkin: '',
        checkout: '',
        tmpcheckout: {},
    });

    const commonStyles = {
        backgroundColor: colors?.primaryBackgroundColor,
        color: colors?.primaryTextColor,
    };

    useEffect(() => {
        // Update the state after the initial render
        setDatesOptions((prevOptions) => ({
            ...prevOptions,
            checkin: tempCheckInDate,
            checkout: tempCheckOutDate,
            tmpcheckout: {},
        }));
    }, [tempCheckInDate, tempCheckOutDate]);
    const [isCalendarOpenModal, setCalendarOpenModal] = useState(false);
    const [isCalendarOpenDrawer, setCalendarOpenDrawer] = useState(false);
    const [nationality, setNationality] = useState(
        pluginCountries[0]?.countryName
    );
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);

    const dropdownOptions = isArray(pluginCountries)
        ? pluginCountries.map((item) => {
              let countryName = item?.countryName;
              if (item?.countryName === 'EN') {
                  countryName = 'US';
              }

              return {
                  dropdownText: item?.countryLocalFullName,
                  dropdownImg: item?.countryImg,
                  dropdownSelected: item?.dropdownSelected,
                  dropdownExtraData: {
                      countryCode: countryName,
                  },
                  dropdownValue: countryName,
              };
          })
        : [];

    let mobileClass = '';
    if (isMobileDevice) {
        mobileClass = 'offer-modal-mobile';
    }

    const clearValues = () => {
        setFirstName('');
        setLastName('');
        setMessage('');
        setEmail('');
        setPhone('');
        setSearchOptions({ numberOfRooms: 1, adults: 2, children: 0 });
        setDatesOptions((prevOptions) => ({
            ...prevOptions,
            checkin: tempCheckInDate,
            checkout: tempCheckOutDate,
            tmpcheckout: {},
        }));
        setIsCompleted('');
        setErrorMessage('');
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        const errors = validateInputs();

        if (!isEmpty(errors)) {
            setErrors(errors);
            return;
        }

        let tmpNationality = nationality;
        if (nationality === 'EN') {
            tmpNationality = 'US';
        }
        try {
            setIsLoading(true);
            const response = await axios.post(apiConfig?.getOfferUrl, {
                curCode: userBookingData?.currency,
                lang: userBookingData?.localeLanguage,
                firstName,
                email,
                phone,
                lastName,
                nationality: tmpNationality,
                propertyID,
                message,
                adults: searchOptions.adults,
                children: searchOptions.children,
                rooms: searchOptions.numberOfRooms,
                checkin: datesOptions.checkin,
                checkout: datesOptions.checkout,
            });

            if (response?.data.toLowerCase() !== 'ok') {
                setIsCompleted('false');
                setErrorMessage(response?.data);
            } else {
                setIsCompleted('true');
            }
        } catch (error) {
            toast.error(Lang?.networkError, {
                autoClose: true,
                theme: 'colored',
            });
        }

        // handleModalClose();
        setIsLoading(false);
    };

    const validateInputs = () => {
        const errors = {};

        const emailRegex =
            // eslint-disable-next-line no-useless-escape
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        if (!firstName) {
            errors.firstName = Lang?.requiredField;
        }

        if (!lastName) {
            errors.lastName = Lang?.requiredField;
        }

        if (!email) {
            errors.email = Lang?.requiredField;
        } else if (!email.match(emailRegex)) {
            errors.email = Lang?.pleaseEnterValidEmail;
        }

        if (!phone) {
            errors.phone = Lang?.requiredField;
        }

        if (!checked) {
            errors.checked = Lang?.requiredField;
        }

        return errors;
    };

    const handleCalendarOpen = () => {
        if (!isMobileDevice) {
            setCalendarOpenModal(true);
        } else {
            setCalendarOpenDrawer(true);
        }
    };

    let redBorderClass = '';
    if (errors?.nationality) {
        redBorderClass = 'ab-reb-border';
    }
    const [currentMonthIndex, setCurrentMonthIndex] = useState(0);
    const renderBookingCalendar = () => (
        <BookingCalendar
            currentMonthIndex={currentMonthIndex}
            setCurrentMonthIndex={setCurrentMonthIndex}
            onDatesClick={(key, value) =>
                setDatesOptions((prevOptions) => ({
                    ...prevOptions,
                    [key]: value,
                }))
            }
            mobile={isMobileDevice}
            setCalendarOpen={() => setCalendarOpenModal(false)}
            datesOptions={datesOptions}
            // variant="singleMonth"
        />
    );

    const renderContent = () => {
        return (
            <div
                className={`ab-contact-us-cnt ab-container ${mobileClass} ${
                    isCompleted ? `ab-offer-success` : ''
                }`}
            >
                {isCompleted === 'true' ? (
                    <div
                        className="ab-offer-form-row"
                        style={{ flexDirection: 'column' }}
                    >
                        <div className="ab-offer-success-top">
                            <FaRegCheckCircle size={50} color="#4ac94a" />
                        </div>
                        <div
                            onClick={() => handleModalClose()}
                            className="ab-offer-success-bottom"
                        >
                            <div className="ab-offer-success-line-one">
                                {Lang?.great}!
                            </div>
                            <div className="ab-offer-success-line-two">
                                {Lang?.checkYourEmailForOurProposal}.
                            </div>
                            <button
                                type="button"
                                className="ab-offer-success-close"
                                style={commonStyles}
                            >
                                X {Lang?.close}
                            </button>
                        </div>
                    </div>
                ) : isCompleted === 'false' ? (
                    <div
                        className="ab-offer-form-row"
                        style={{ flexDirection: 'column' }}
                    >
                        <div className="ab-offer-success-top">
                            <FaRegTimesCircle size={50} color="#c51f1f" />
                        </div>
                        <div
                            onClick={() => handleModalClose()}
                            className="ab-offer-success-bottom"
                        >
                            <div className="ab-offer-success-line-one">
                                {Lang?.somethingWentWrong}!
                            </div>
                            <div className="ab-offer-success-line-two">
                                {errorMessage}.
                            </div>
                            <button
                                type="button"
                                className="ab-offer-success-close"
                                style={commonStyles}
                            >
                                X {Lang?.close}
                            </button>
                        </div>
                    </div>
                ) : (
                    <form
                        className="ab-contact-us-form ab-form"
                        onSubmit={handleSubmit}
                        noValidate
                    >
                        <p className="ab-offer-prompt-text">
                            {Lang?.tellUsYourBookingRequest}
                        </p>

                        <div className="ab-offer-form-row">
                            <div className="ab-input-group">
                                <div className="ab-input-field-cnt">
                                    <BookingCalendarLite
                                        onClick={() => handleCalendarOpen()}
                                        datesOptions={datesOptions}
                                    />
                                </div>
                            </div>
                            {!isMobileDevice && (
                                <div className="ab-input-group">
                                    <div className="ab-input-field-cnt">
                                        <BookingDropdownLite
                                            onChange={(key, value) =>
                                                setSearchOptions(
                                                    (prevOptions) => ({
                                                        ...prevOptions,
                                                        [key]: value,
                                                    })
                                                )
                                            }
                                            searchOptions={searchOptions}
                                        />{' '}
                                    </div>
                                </div>
                            )}
                        </div>
                        {isMobileDevice && (
                            <div className="ab-offer-form-row">
                                <div className="ab-input-field-cnt">
                                    <BookingDropdownLite
                                        onChange={(key, value) =>
                                            setSearchOptions((prevOptions) => ({
                                                ...prevOptions,
                                                [key]: value,
                                            }))
                                        }
                                        searchOptions={searchOptions}
                                    />{' '}
                                </div>
                            </div>
                        )}
                        <p className="ab-offer-prompt-text">
                            {Lang?.personalInformation}
                        </p>
                        <div className="ab-offer-form-row">
                            <div className="ab-input-group">
                                <div className="ab-input-field-cnt">
                                    <Input
                                        type="text"
                                        placeholder={Lang?.firstName}
                                        value={firstName}
                                        onChange={(event) => {
                                            setFirstName(event.target.value);
                                        }}
                                        isInvalid={Boolean(errors?.firstName)}
                                        errorMsg={errors.firstName}
                                        isRequired
                                        id="contact-us-full-name"
                                        label={Lang?.firstName}
                                        name="firstname"
                                        autoComplete="given-name"
                                    />
                                </div>
                            </div>
                            <div className="ab-input-group">
                                <div className="ab-input-field-cnt">
                                    <Input
                                        type="text"
                                        placeholder={Lang?.lastName}
                                        value={lastName}
                                        onChange={(event) => {
                                            setLastName(event.target.value);
                                        }}
                                        isInvalid={Boolean(errors?.lastName)}
                                        errorMsg={errors.lastName}
                                        isRequired
                                        id="contact-us-full-name"
                                        label={Lang?.lastName}
                                        name="lastname"
                                        autoComplete="family-name"
                                    />
                                </div>
                            </div>
                            <div className="ab-input-group">
                                <div
                                    className="ab-input-field-cnt"
                                    style={{
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                    }}
                                >
                                    <label
                                        className="ab-input-label"
                                        style={{
                                            marginBottom: '5px',
                                        }}
                                    >
                                        {Lang.nationality}
                                    </label>
                                    <Dropdown
                                        onChange={(option) => {
                                            setNationality(
                                                option?.dropdownExtraData
                                                    ?.countryCode
                                            );
                                        }}
                                        searchable
                                        options={dropdownOptions || []}
                                        showTextWhenSelected={true}
                                        extraClass={`ab-nationality-dropdown ${redBorderClass}`}
                                        id="form-Nationality"
                                        maxHeight="250px"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="ab-offer-form-row">
                            <div className="ab-input-group">
                                <div className="ab-input-field-cnt">
                                    <Input
                                        type="text"
                                        placeholder={Lang?.email}
                                        value={email}
                                        onChange={(event) => {
                                            setEmail(event.target.value);
                                        }}
                                        isInvalid={Boolean(errors?.email)}
                                        errorMsg={errors.email}
                                        isRequired
                                        id="contact-us-full-name"
                                        label={Lang?.email}
                                        name="email"
                                        autoComplete="email"
                                    />
                                </div>
                            </div>
                            <div className="ab-input-group">
                                <div className="ab-input-field-cnt">
                                    <Input
                                        type="text"
                                        placeholder={Lang?.phone}
                                        value={phone}
                                        onChange={(event) => {
                                            setPhone(event.target.value);
                                        }}
                                        isInvalid={Boolean(errors?.phone)}
                                        errorMsg={errors.phone}
                                        isRequired
                                        id="contact-us-full-name"
                                        label={Lang?.phone}
                                        name="phone"
                                        autoComplete="tel"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="ab-offer-form-row">
                            <div className="ab-input-group">
                                <div className="ab-input-field-cnt">
                                    <Input
                                        type="textarea"
                                        placeholder={Lang?.message}
                                        value={message}
                                        onChange={(event) => {
                                            setMessage(event.target.value);
                                        }}
                                        id="contact-us-full-name"
                                        label={Lang?.message}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="ab-offer-form-row">
                            {' '}
                            <label
                                className="ab-input-group"
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                }}
                                id="form-checkbox"
                            >
                                <Checkbox
                                    className="ab-booking-form-checkbox"
                                    id="termsCheck"
                                    isChecked={checked}
                                    onChange={(event) =>
                                        setChecked(event.target.checked)
                                    }
                                ></Checkbox>
                                <span
                                    style={{
                                        paddingRight: '3px',
                                    }}
                                >
                                    {Lang?.iHaveReadAndIAcceptThe}
                                </span>

                                {Lang?.TmpTermsAndConditions && (
                                    <>
                                        <a
                                            className="ab-booking-form-terms-inner"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            href={Lang?.TmpTermsAndConditions}
                                        >
                                            <span className="ab-booking-form-terms-inner">
                                                {Lang?.termsAndConditions}
                                            </span>

                                            <span
                                                style={{
                                                    padding: '0 3px',
                                                }}
                                            >
                                                &
                                            </span>
                                            {Lang?.privacyPolicy}
                                        </a>
                                    </>
                                )}

                                {Boolean(errors?.checked) && (
                                    <span className="ab-booking-form-check-required">
                                        {Lang?.requiredField}
                                    </span>
                                )}
                            </label>
                        </div>

                        <button
                            type="submit"
                            className="ab-offer-submit ab-book-button ab-book-button--non-member"
                            disabled={isLoading}
                        >
                            {isLoading ? (
                                <BarsLoadingIndicator />
                            ) : (
                                Lang?.getAQuote
                            )}
                        </button>
                    </form>
                )}
            </div>
        );
    };

    return (
        <>
            <Modal
                className="ab-modal--offer"
                color={colors?.primaryTextColor}
                backgroundColor={colors?.primaryBackgroundColor}
                isOpen={isOpen}
                onClose={handleModalClose}
                onOverlayClick={handleModalClose}
                placement="center"
                renderContent={renderContent}
                styles={{
                    closeIcon: { color: 'black' },
                }}
                title={Lang?.letUsCreateProposal}
                variant="white-header"
                width={620}
            />

            {!isMobileDevice ? (
                <Modal
                    className="ab-modal--calendar-us"
                    color={colors?.primaryTextColor}
                    backgroundColor={colors?.primaryBackgroundColor}
                    isOpen={isCalendarOpenModal}
                    onClose={() => setCalendarOpenModal(false)}
                    onOverlayClick={() => setCalendarOpenModal(false)}
                    placement="center"
                    renderContent={renderBookingCalendar}
                    styles={{
                        closeIcon: { color: colors?.primaryTextColor },
                    }}
                    title={Lang?.selectDates}
                    variant="secondary"
                    width={1000}
                />
            ) : (
                <Drawer
                    anchor="bottom"
                    backdrop
                    elevation={constants.MAX_ZINDEX_VALUE}
                    open={isCalendarOpenDrawer}
                    width="100%"
                    height="100%"
                    className="ab-mobile-carousel"
                >
                    <>
                        <BookingHeader
                            iconColor="#1a2024"
                            onClick={() => setCalendarOpenDrawer(false)}
                            extraClass="show-import"
                        />
                        <BookingCalendar
                            currentMonthIndex={currentMonthIndex}
                            setCurrentMonthIndex={setCurrentMonthIndex}
                            onDatesClick={(key, value) =>
                                setDatesOptions((prevOptions) => ({
                                    ...prevOptions,
                                    [key]: value,
                                }))
                            }
                            mobile={isMobileDevice}
                            setCalendarOpen={() => setCalendarOpenDrawer(false)}
                            datesOptions={datesOptions}
                            // variant="singleMonth"
                        />
                    </>
                </Drawer>
            )}
        </>
    );
};

export default OfferModal;
